import { render, staticRenderFns } from "./BannerRight.vue?vue&type=template&id=ae6f08ee"
import script from "./BannerRight.vue?vue&type=script&lang=ts"
export * from "./BannerRight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports